import * as React from 'react';
import {User} from 'lucide-react';
import ResourceFigure from './ResourceFigure';

export default function ClientResourceFigure({className}) {
	return (
		<ResourceFigure
			icon={User}
			bgClassName="bg-purple-50 border-purple-200"
			iconClassName="text-purple-500"
			className={className}
		/>
	);
}
